// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Interns from './pages/Interns';
import Offers from './pages/Offers';
import ServiceBooking from './pages/ServiceBooking';
import Blogs from './pages/Blogs';
import APage from './pages/APage';
import AdminLogin from './pages/AdminLogin';
import ManageInterns from './pages/ManageIntens';
import PrivateRoute from './components/PrivateRoute';
import Terms from './pages/TermsServices';
import NotFound from './pages/NotFound'; // 👈 create this page for 404 handling
import CertificateVerification from './pages/CertificateVerification';

import HowToCreateReactWeb from './pages/blogs/BlogReactResponsive';
import BlogAIStartup from './pages/blogs/BlogAIStartup';
import BlogReactAdvancedTips from './pages/blogs/BlogReactAdvancedTips';
import ReactWebBestPractices from './pages/blogs/BlogReactWebBestPractices';
import StartupWebsite2026 from './pages/blogs/BlogStartupWebsite2026';
import UIDesignPrinciples from './pages/blogs/BlogUIDesignPrinciples';
import HostingerBlog from './pages/blogs/HostingerBlog';
import HostingBlog from './pages/blogs/HostingBlog';

import WebsiteDevelopmentService from './pages/services/WebsiteDevelopment';
import DubaiWebsiteDevelopmentService from './pages/services/WebsiteDevelopmentDubai';
import AISolutionService from './pages/services/AISolutions';
import MobileAppService from './pages/services/MobileAppDevelopment';
import ChinaLandingFull from './pages/services/ChinaLandingFull';
import HostingerHosting from './pages/services/Hosting';

//admissions Routes

import StudentsLanding from './pages/StudentStudies/StudentsLanding';
import Admission from './pages/StudentStudies/AdmissionForm';

//Apps Routes

import UdharManagerApp from './pages/apps/UdhaarManager';

import './App.css';
import AdmissionForm from './pages/StudentStudies/AdmissionForm';

function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-gray-50 text-gray-900">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/serviceBooking" element={<ServiceBooking />} />
            <Route path="/alogin" element={<AdminLogin />} />
            <Route path="/interns" element={<Interns />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/certificates_SamSoftix" element={<CertificateVerification />} />
            
            {/* ✅ Blog  Routes */}
             <Route path="/write_blog_requirements" element={<Blogs />} />
            <Route path="/Create_React_Js_App" element={<HowToCreateReactWeb />} />
            <Route path="/React_Advanced_Tips" element={<BlogReactAdvancedTips />} />
            <Route path="/React_Best_Practices" element={<ReactWebBestPractices />} />
            <Route path="/StartUp_Website_2026" element={<StartupWebsite2026 />} />
            <Route path="/AI_Startup_blog" element={<BlogAIStartup />} />
            <Route path="/UI_Design_Principles" element={<UIDesignPrinciples />} />
            <Route path="/GetHosting" element={<HostingBlog />} />
            <Route path="/HostingerHosting" element={<HostingerBlog />} />

            
            {/* ✅ Services  Routes */}
             <Route path="/all_services" element={<Services />} />
             <Route path="/website_Service_Samsoftix" element={<WebsiteDevelopmentService/>} />
             <Route path="/Dubai_Website_Service_SamSoftix" element={<DubaiWebsiteDevelopmentService />} />
             <Route path="/Mobile_App_Service_SamSoftix" element={<MobileAppService/>} />
             <Route path="/AI_Solutions_SamSoftix" element={<AISolutionService/>} />
             <Route path="/SoftwareDevChina" element={<ChinaLandingFull/>} />
             <Route path="/GetHostingDomain" element={<HostingerHosting/>} />


             {/* ✅ Services  Routes */}
             <Route path="/Skills-Learning-Portal" element={<StudentsLanding/>} />
             <Route path="/admission" element={<AdmissionForm/>} />

             {/* ✅ Apps  Routes */}
             <Route path="/UdharManagerApp" element={<UdharManagerApp/>} />


            {/* ✅ Protected Admin Routes */}
            <Route
              path="/apage"
              element={
                <PrivateRoute>
                  <APage />
                </PrivateRoute>
              }
            />

            <Route
              path="/mInterns"
              element={
                <PrivateRoute>
                  <ManageInterns />
                </PrivateRoute>
              }
            />

            {/* 🚫 404 Page */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
